import { SupplyFitEnginesQuoteDataProps } from "../types";
import { supplyFitEngines } from "./supplyFitEngines";

export const supplyFitEnginesQuoteData: SupplyFitEnginesQuoteDataProps = {
  headingPart1: "Reconditioned Engines",
  headingPart2: " Ready for ",
  headingPart3: " Supply and Fit",
  description:
    "Browse a selection of engines we regularly supply and fit across the Range Rover and Land Rover range. Every unit is tested, warrantied and fitted by specialists who know these platforms inside out.",
  noticeText:
    "If you need a specific Range Rover or Land Rover engine code in Grays England, contact our team and we will confirm availability, lead time and a full supply-and-fit price.",
  engines: supplyFitEngines,
};
